import { PaginationMeta } from './PaginationMeta'

export interface User {
    id: number
    login: string
    level: number
    password?: string
}

export enum UserCategory {
    ADMIN = 0,
    EDITOR = 1,
    SUBSCRIBER = 2,
    VISITOR = 3,
}

export interface UsersResponse {
    links: any
    meta: PaginationMeta
    value: User[]
}
